
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/article/SafeOnlineShopping",
      function () {
        return require("private-next-pages/article/SafeOnlineShopping.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/article/SafeOnlineShopping"])
      });
    }
  